import React from 'react'

import { KinerjaHarianRoleContext } from 'app/KinerjaHarian/hooks/useKinerjaHarianRoleContext'

import type { KinerjaHarianRole } from 'types/kinerja-harian'

type Props = {
  role: KinerjaHarianRole
  children: React.ReactNode
}

export function KinerjaHarianRoleProvider({ role, children }: Props) {
  const contextValue = React.useMemo(() => ({ role }), [role])
  return (
    <KinerjaHarianRoleContext.Provider value={contextValue}>
      {children}
    </KinerjaHarianRoleContext.Provider>
  )
}
